import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { DataAccessTogglesFacade } from '@planone/shared/data-access-feature-flags';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WatchlistEnabledGuard {
  private watchlistDisabled$: Observable<boolean | undefined>;

  constructor(private readonly router: Router, private feature: DataAccessTogglesFacade) {
    this.watchlistDisabled$ = this.feature.flag('kill-watchlist');
  }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.watchlistDisabled$.pipe(
      map((watchlistDisabled) => (watchlistDisabled ? this.router.parseUrl(`/`) : true))
    );
  }
}
